import React, { useCallback, useEffect, useRef } from "react";
import css from "components/mobile/meeting/calendar/calendar.module.css";
import "./calendar.css";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import FullCalendar from "@fullcalendar/react";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

/**
 * 파일명: body.js
 * 작성자: 권도훈
 * 작성일자: 25.02.24
 * 설명: 모바일 페이지 캘린더 바디
 */
function Body({
  schedules,
  view,
  locale,
  calendarApi,
  setCalendarApi,
  onChangeDate,
  onChangeView,
  onEdit,
  onOpenMore,
}) {
  const calendarRef = useRef(null);

  useEffect(() => {
    if (calendarApi === undefined && calendarRef !== null) {
      setCalendarApi(calendarRef.current.getApi());
    }
  }, [calendarApi, setCalendarApi]);

  const dateLabelFormat = (date) => {
    return date.replace("일", "");
  };

  return (
    <section className={css.body}>
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView={view}
        locale={locale}
        timeZone="Asia/Seoul"
        headerToolbar={false}
        unselectAuto={true}
        events={schedules}
        views={{
          dayGridMonth: {
            titleFormat: {
              year: "numeric",
              month: "2-digit",
            },
            dayCellContent: (arg) => {
              return (
                <p
                  className={
                    arg.isToday
                      ? `${css.calendar_cell_txt} ${css.today}`
                      : arg.dow === 0
                      ? `${css.calendar_cell_txt} ${css.sun}`
                      : arg.dow === 6
                      ? `${css.calendar_cell_txt} ${css.sat}`
                      : css.calendar_cell_txt
                  }
                >
                  {dateLabelFormat(arg.dayNumberText)}
                </p>
              );
            },
            dateClick: (info) => {
              onChangeDate(info.date);
              onChangeView();
            },
            dayHeaderClassNames: css.calendar_header,
            dayHeaderContent: (arg) => {
              return <p className={css.calendar_header_txt}>{arg.text}</p>;
            },
            eventContent: (arg) => {
              return arg.event._def.title;
            },
            eventClick: (arg) => {
              //과거인 경우, 현재인 경우, 미래인 경우 분류 필요.
              //Resource.js 참고
              onEdit(arg.event._def.extendedProps.data);
            },
            dayMaxEventRows: true,
            moreLinkContent: (arg) => {
              return (
                <div className={css.calendar_more_btn}>
                  <PlusOutlined className={css.calendar_more_icon} />
                  <p className={css.calendar_more_txt}>{arg.num}개</p>
                </div>
              );
            },
            moreLinkClick: (info) => {
              onChangeDate(info.date);
              onChangeView();
            },
          },
          timeGridWeek: {
            type: "timeGrid",
            nowIndicator: true,
            eventMaxStack: 1,
            slotLabelFormat: {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            },
            slotLabelContent: (arg) => {
              return <p className={css.calendar_slot}>{arg.text}</p>;
            },
            slotDuration: "00:10:00",
            eventTimeFormat: {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            },
            allDaySlot: false,
            dayHeaderContent: (arg) => {
              return (
                <div className={css.calendar_week_header}>
                  <p>{dayjs(arg.date).locale(locale).format("ddd")}</p>
                  <div
                    className={
                      arg.isToday
                        ? `${css.calendar_week_days} ${css.today}`
                        : css.calendar_week_days
                    }
                  >
                    {dayjs(arg.date).locale(locale).format("DD")}
                  </div>
                </div>
              );
            },
            eventContent: (arg) => {
              return (
                <>
                  <p className={css.calendar_week_title}>
                    {arg.event._def.title}
                  </p>
                  <p className={css.calendar_week_title}>{arg.timeText}</p>
                </>
              );
            },
            eventClick: (arg) => {
              //과거인 경우, 현재인 경우, 미래인 경우 분류 필요.
              //Resource.js 참고
              onEdit(arg.event._def.extendedProps.data);
            },
            moreLinkClick: (info) => {
              onOpenMore(info.allSegs);
              return <></>;
            },
          },
        }}
      />
    </section>
  );
}

export default Body;
